/**
 * Just a place to keep all keys used for local storage across the app
 */
export enum LocalStorageKeys {
    // latest selected active taxonomy
    ACTIVE_TAXONOMY = 'active-taxonomy',
    // current token's expiration time
    TOKEN_EXPIRES = 'token_expires',
    // current auth token's roles
    TOKEN_ROLES = 'token_roles',
    // column sorting order
    TUPLE_TABLE_COLS = 'tuple-table-columns',
}
